var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2169_14180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.3107,
    cy: 33.2956,
    r: 29.1034,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6028 23.4258C42.8094 23.0996 43.1686 22.9019 43.5547 22.9019C44.0733 22.9019 44.4937 23.3223 44.4937 23.8408V29.8313C44.4937 30.0329 44.6356 30.2067 44.8331 30.247L48.7217 31.0406C49.1417 31.1263 49.3484 31.6038 49.1234 31.9686L46.8689 35.6245L51.3371 39.8135C51.7559 40.2061 51.7772 40.8639 51.3845 41.2827C51.0221 41.6693 50.4338 41.7171 50.016 41.4134L49.9154 41.3301L33.2848 25.739C32.866 25.3463 32.8448 24.6886 33.2374 24.2698C33.5998 23.8832 34.1882 23.8354 34.6059 24.1391L34.7066 24.2224L39.3445 28.5704L42.6028 23.4258ZM37.4119 31.622L44.9685 38.7063L42.2079 43.1829C42.0135 43.4981 41.6697 43.69 41.2994 43.69C40.71 43.69 40.2321 43.2122 40.2321 42.6227V36.4733C40.2321 36.4389 40.2078 36.4093 40.1741 36.4026L36.5494 35.6776C35.8195 35.5317 35.4631 34.6989 35.8614 34.0701L37.4119 31.622Z",
    fill: "#363D4E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2169_14180",
    x: 0.734368,
    y: 0.034503,
    width: 83.1526,
    height: 83.1526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.15764,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2169_14180"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.31527
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.31527
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2169_14180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2169_14180",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.66972ea486b34edcf2d96fa4a1273969.svg";
export { ForwardRef as ReactComponent };